<template>
  <div id="wrapper">
    <component-sidebar :force-mini="false"/>
    <div id="page-wrapper">
      <div class="row" style="background: #293846;">
        <div class="col-lg-12 animated fadeInRight gray-bg" style="min-height: 100vh;">
          <component-header :hide-expand-button="true"/>
          <div class="row wrapper border-bottom white-bg page-heading">
            <div class="col-lg-12 white-bg">
              <h2>{{ $route.meta.name }}</h2>
              <ol class="breadcrumb">
                <li>
                  <router-link to="/cession/list">Liste des cessions </router-link>
                </li>
                <li>
                  <a>Cession #{{ commandId }}</a>
                </li>
                <li class="active">
                  <strong>{{ $route.meta.name }}</strong>
                </li>
              </ol>
            </div>
          </div>
          <div v-if="!hasResult" class="wrapper-content"><spinner-three-bounce/></div>
          <div v-else class="wrapper-content">
            <general-infos
              :command="command"
              :canEditVehicle="false"
              :canEditBuyer="false"
              :canEditSeller="false"
              :price="command.buyerPrice"
              :vehicle="vehicle"
              :seller="seller"
              :buyer="buyer"
            />

            <!-- Documents du véhicule avant la vente -->
            <Accordion title="Documents du véhicule" titleIcon="fa fa-files-o" :expandedProp="true">
              <template slot="label">
                    <label
                      v-bind:class="{ 'label-danger': !beforeSaleDocumentsRequiredAndValid.length,
                        'label-warning': beforeSaleDocumentsRequiredAndValid.length && !beforeSaleDocumentsReady,
                        'label-primary': beforeSaleDocumentsReady }"
                      class="label label-documents">
                      {{ beforeSaleDocumentsRequiredAndValid.length }}/{{ beforeSaleDocumentsRequired.length }}
                    </label>
              </template>
              <template slot="content">
                    <div class="row">
                      <component-document
                        @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                        :command="command"
                        :ownerInformation="ownerInformation"
                        :futureOwner="futureOwner"
                        v-for="(doc, key) in beforeSaleDocuments"
                        v-bind:key="'A' + key"
                        v-bind:document="doc"
                      />
                    </div>
              </template>
            </Accordion>
            <!-- Fin des docs du véhicule avant la vente -->

            <!-- instruction -->
            <Accordion title="Rendez-vous de cession" titleIcon="fa fa-calendar" :expandedProp="true">
              <template slot="content">
                <div class="row m-b-md">
                  <div class="col-lg-12">
                    <component-status :status="status"></component-status>
                  </div>
                </div>
                <div class="row m-b-md">
                  <div class="col-lg-12">
                    <b>Attention</b> : c'est une cession pour <b>{{ order[0].realm | capitalize }}</b><br><br>
                    Date de rdv : <b> {{saleRdv.date | formatDateTime }}</b><br>
                    Lieu de rdv : <b> {{saleRdv.address.address}}, {{saleRdv.address.zipCode}} {{saleRdv.address.city}} </b>
                  </div>
                </div>
                <div class="row m-b-md">
                  <div class="col-lg-12" v-if="commercial">
                    Chez Carizy cette commande est gérée par : <b>{{commercial.firstname}}</b>
                  </div>
                </div>
                <div class="row m-b-md">
                  <div class="col-lg-12">
                    <template v-if="paymentMode == 0">
                       Mode de règlement : <b>pas encore enregistré </b>
                      <i class="fa  fa-info-circle"></i>
                    <br>
                    </template>
                    <template v-if="paymentMode == 1">
                     Mode de règlement : <b>Chèque de banque </b><span v-tooltip.top-center="'L\'acheteur remettra le chèque de banque au vendeur en cas de réussite de la vente.'">
                      <i class="fa  fa-info-circle"></i>
                    </span>  <br>
                    </template>
                    <template v-if="paymentMode == 2">
                    Mode de règlement : <b>Virement bancaire </b><span v-tooltip.top-center="'Carizy a déjà récupéré les fonds sur un compte séquestre. Ils seront transférés sur le compte du vendeur en cas de réussite de la vente.'">
                      <i class="fa  fa-info-circle"></i>
                    </span>  <br>
                    </template>
                   <template v-if="paymentMode == 3">
                    Mode de règlement : <b>Financement</b><span v-tooltip.top-center="'Carizy a déjà récupéré les fonds sur un compte séquestre. Ils seront transférés sur le compte du vendeur en cas de réussite de la vente.'">
                      <i class="fa  fa-info-circle"></i>
                    </span>  <br>
                   </template>
                  </div>
                </div>
                <p class="text-center m-t-md"><small>Un doute sur l’organisation d’un rendez-vous de cession ? <a href="https://drive.google.com/file/d/1cQp3WnbEZEDc1H2ArcjOKSovog-UDVYw/view" target="_blank" >Consultez notre fiche pratique (en pdf)</a></small></p>
              </template>
            </Accordion>
            <!-- fin instruction -->

            <div v-if="displayPurchaseProjectSection" class="alert alert-success">
              <span class="alert-link">Attention</span>,
              <span v-if="order[0].purchaseProject === 'new'">
                le vendeur a déclaré avoir un projet d’achat de véhicule neuf.
              </span>
              <span v-if="order[0].purchaseProject === 'used'">
                le vendeur a déclaré avoir un projet d’achat de véhicule d'occasion.
              </span>
              <span v-if="order[0].purchaseProject === 'both'">
                le vendeur a déclaré avoir un projet d'achat d'un véhicule neuf ou d'occasion.
              </span>
            </div>

             <!--  Documents de la vente  -->
             <Accordion title="Documents de la vente" titleIcon="fa fa-files-o" :expandedProp="true">
              <template slot="label">
                    <label
                      v-bind:class="{ 'label-danger': !saleDocumentsRequiredAndValid,
                          'label-warning': saleDocumentsRequiredAndValid && !saleDocumentsReady,
                          'label-primary': saleDocumentsReady }"
                      class="label label-documents">
                      {{ saleDocumentsRequiredAndValid }}/{{ saleDocumentsRequired }}
                    </label>
              </template>
              <template slot="content">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="m-t-md">
                          <h4>Documents à imprimer impérativement</h4>
                        </div>

                        <component-generated-document
                          :command="command"
                          v-for="(doc, key) in saleDocumentsToGenerateAndPrint"
                          v-bind:key="'B' + key"
                          v-bind:document="doc"
                          v-if="doc.query !== 'generateInvoice'"
                          :subSection="subSectionForSaleDocumentsToGenerateAndPrint"
                        />

                        <component-document
                          @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                          :command="command"
                          :ownerInformation="ownerInformation"
                          :futureOwner="futureOwner"
                          v-for="(doc, key) in saleDocumentsToUploadAndPrint"
                          v-bind:key="'C' + key"
                          v-bind:document="doc"
                          :subSection="subSectionForSaleDocumentsToUploadAndPrint"
                        />
                      </div>
                      <div class="col-lg-6">
                        <div class="m-t-md">
                          <h4>Documents à consulter pendant le rendez-vous <small>(à imprimer ou à consulter sur votre téléphone ou tablette)</small></h4>
                        </div>

                        <component-generated-document
                          :command="command"
                          v-for="(doc, key) in saleDocumentsToGenerateAndConsult"
                          v-bind:key="'D' + key"
                          v-bind:document="doc"
                          :subSection="subSectionForSaleDocumentsToGenerateAndConsult"
                        />

                        <div v-if="paymentMode == 1">
                          <component-document
                            @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                            :command="command"
                            :ownerInformation="ownerInformation"
                            :futureOwner="futureOwner"
                            v-for="(doc, key) in saleDocumentsToUploadBankCheck"
                            v-bind:key="'E' + key"
                            v-bind:document="doc"
                            :subSection="subSectionForSaleDocumentsToUploadAndConsult"
                          />
                        </div>

                        <component-document
                          @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                          :command="command"
                          :ownerInformation="ownerInformation"
                          :futureOwner="futureOwner"
                          v-for="(doc, key) in saleDocumentsToUploadAndConsult"
                          v-bind:key="'F' + key"
                          v-bind:document="doc"
                          :subSection="subSectionForSaleDocumentsToUploadAndConsult"
                        />
                      </div>
                    </div>
              </template>
            </Accordion>
            <!-- end Documents de la vente -->
            <Accordion title="Résultat du rendez-vous" titleIcon="fa fa-car" :expandedProp="true"
                       v-if="isSaleRdvDateReached && (isCarProclaimedSold() || isCarProclaimedUnsold())">
              <template slot="content">
                      <div class="row">
                        <div class="col-lg-12">
                            <template v-if="isCarProclaimedSold()">
                            <p class="bold text-navy valid-message"><i class="fa fa-2x fa-check-circle"></i> Vous avez déclaré le véhicule vendu.</p>
                            <p>Vous devez <b>envoyer à Carizy</b> les documents suivants en recommandé ou lettre suivie :</p>
                            <ul>
                              <li>1 exemplaire du <b>bon de remise signé</b></li>
                              <li>2 exemplaires de la <b>garantie mécanique MAPFRE signés</b></li>
                            </ul>
                              <p>
                                <i class="fa fa-envelope"></i>
                                Carizy
                                KWERK TOUR FIRST
                                1 place des Saisons, CS 30106,
                                92 048 PARIS LA DEFENSE
                              </p>
                            </template>
                            <template v-else-if="isCarProclaimedUnsold()">
                              <p class="bold text-danger valid-message"> <i class="fa fa-2x fa-times-circle"></i>Vous avez déclaré le véhicule non vendu.</p>
                            </template>
                        </div>
                      </div>
              </template>
            </Accordion>
              <!-- end véhicule vendu -->
            <template>
              <div class="row ibox">
                  <div class="col-lg-12 text-center">
                    <div class="pull-left" v-if="isSaleRdvDateReached && (!isCarProclaimedSold() && !isCarProclaimedUnsold())">
                      <a class="btn btn-danger btn-cancel" type="button"  data-toggle="modal" href="#noSoldCar"><i class="fa fa-times" ></i> Je déclare le véhicule non vendu</a>
                    </div>
                    <a class="btn btn-primary text-center" type="button" v-on:click="onOpenModal" data-toggle="modal" v-if="isSaleRdvDateReached && (!isCarProclaimedSold() && !isCarProclaimedUnsold())" href="#soldCar"><i class="fa fa-check"></i> Je déclare le véhicule vendu</a>
                  </div>
              </div>
            </template>
          </div>
          <!--  MODAL modal véhicule vendu  ----->
          <div v-if="hasResult" class="modal inmodal modal-soldCar fade in" id="soldCar" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body">
                      <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">Close</span>
                      </button>
                      <div class="row text-center animated fadeInDown">
                        <div class="col-lg-12">
                          <div class="m-b-md">
                            <h2 class="font-bold">Êtes-vous sûr(e) de vouloir déclarer le véhicule vendu ?</h2>
                            <div class="col-lg-12 m-t-md">
                              <button class="m-b-xl m-r-xs btn btn-default"  data-dismiss="modal">Annuler</button>
                              <button type="submit"  v-on:click="onSoldProclamation" class="m-b-xl btn btn-primary" data-dismiss="modal">Oui, déclarer vendu</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
          <!-- end modal véhicule vendu -->
          <!-- modal véhicule non vendu -->
          <div v-if="hasResult" class="modal inmodal modal-noSoldCar fade in" id="noSoldCar" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body">
                      <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">Close</span>
                      </button>
                      <div class="row text-center animated fadeInDown">
                        <div class="col-lg-12">
                          <div class="">
                            <h2 class="font-bold">Etes-vous sûr de vouloir déclarer le véhicule non vendu ?</h2>
                            <div class="col-lg-12 m-t-md">
                              <button class="m-b-xl m-r-xs btn btn-default" data-dismiss="modal">Annuler</button>
                              <button type="submit" v-on:click="onUnsoldProclamation" class="m-b-xl btn btn-danger" data-dismiss="modal">Oui, déclarer non vendu</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
             </div>
           </div>
          <!-- end modal véhicule non vendu -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import moment from 'moment'
  import 'moment/locale/fr'
  import store from '../config/store'
  import Accordion from '../components/accordion/accordion'
  import Document from '../components/details/documents/Document.vue'
  import GeneralInfos from '../components/details/GeneralInfos'
  import GeneratedDocument from '../components/details/documents/GeneratedDocuments.vue'
  import Header from '../components/Header.vue'
  import Sidebar from '../components/Sidebar.vue'
  import SpinnerThreeBounce from '../components/spinners/SpinnerThreeBounce'
  import Status from '../components/details/Status.vue'

  export default {
    components: {
      GeneralInfos,
      'component-header': Header,
      'component-sidebar': Sidebar,
      'component-status': Status,
      'component-document': Document,
      'component-generated-document': GeneratedDocument,
      Accordion,
      SpinnerThreeBounce
    },
    data: () => ({
      counter: 0,
      order: null,
      beforeSaleDocuments: [
        {
          id: "",
          title: "Certificat d'immatriculation",
          code: "carRegistration",
          valid: false,
          page: "partner"
        },
        {
          id: "",
          title: "Contre visite (optionnelle)",
          code: "consVisit",
          valid: false,
          page: "partner"
        },
        {
          id: "",
          title: "Controle technique",
          code: "vehicleInspection",
          valid: false,
          page: "partner"
        }
      ],
      saleDocumentsToGenerateAndPrint: [
        {
          title: "Certificat de cession",
          query: 'generateCertifCession',
          base64: "",
          formIsCompleted: false,
          canGenerate: false,
          page: "partner",
          infoPartner: 'generateCertifCession'
        },
        {
          title: "Facture vendeur",
          query: 'generateInvoice',
          base64: "",
          canGenerate: false,
          page: "partner",
          infoPartner: 'generateInvoice'
        },
        {
          title: "Bon de remise",
          query: 'generateDisposal',
          base64: "",
          canGenerate: false,
          page: "partner",
          infoPartner: 'generateDisposal'
        },
        {
          title: "Bon de commande",
          query: 'generateDisposal',
          base64: "",
          canGenerate:  false,
          page: 'partner',
          infoPartner: 'generateDisposal'
        }
      ],
      subSectionForSaleDocumentsToGenerateAndPrint: true,
      saleDocumentsToUploadAndPrint: [
        {
          id: "",
          title: "Bulletin de souscription - Garantie",
          code: "warrantyMecanique",
          valid: false,
          page: "partner",
          infoPartner: "warrantyMecanique"
        },
        {
          id: "",
          title: "Certificat de situation administrative",
          code: "nonPedge",
          valid: false,
          page: "partner",
          infoPartner: "nonPedge"
        }
      ],
      subSectionForSaleDocumentsToUploadAndPrint: true,
      saleDocumentsToGenerateAndConsult: [
        {
          title: "Rapport d'inspection",
          query: 'generateExpertiseReport',
          base64: "",
          canGenerate: false,
          page: "partner",
          infoPartner: 'generateExpertiseReport'
        },
      ],
      subSectionForSaleDocumentsToGenerateAndConsult: true,
      saleDocumentsToUploadBankCheck: [
        {
          id: "",
          title: "Copie du chèque de banque",
          code: "bankCheck",
          valid: false,
          page: "partner",
          infoPartner: "bankCheck"
        },
      ],
      saleDocumentsToUploadAndConsult: [
        {
          id: "",
          title: "Procuration du propriétaire",
          code: "procuration",
          valid: false,
          user: "owner",
          page: "partner",
          infoPartner: "procuration"
        },
        {
          id: "",
          title: "Procuration du co-propriétaire",
          code: "procuration",
          valid: false,
          user: "coOwner",
          page: "partner",
          infoPartner: "procuration"
        },
        {
          id: "",
          title: "Procuration du futur propriétaire",
          code: "procuration",
          valid: false,
          user: "futureOwner",
          page: "partner",
          infoPartner: "procuration"
        },
      ],
      subSectionForSaleDocumentsToUploadAndConsult: true,
      checkedValidDocumentsList: [],
      carDocuments: [],
      showRdv: false,
      showDone: false,
      showFail: false,
      isNewCarRegistrationDeclaredByPartner: null,
      choiceDone: true,
      dowloadDoc:[],
      showButton:true,
      saleRdvStatus: null,
      userInfos: {
        userProfil: null,
        userIsManager: false,
        managerId: "",
        userIsExpert: false,
        expertId: "",
        expertiseCompany: ""
      },
    }),
    computed: {
      displayPurchaseProjectSection () {
        return false
      },
      isSaleRdvDateReached:  function ()  {
        return moment().unix() > moment( this.saleRdv.date , 'DD-MM-YYYY HH-mm-ss').unix()
      },
      commandDetailQuery () {
        return gql`
          { order (id: "${this.commandId}") {
            id
            realm
            status {
              id
              label
            }
            purchaseProject
            delivery
            buyerPrice
            paymentMode
            saleCommission
            commercial {
              id
              firstname
              lastname
            }
            options {
              id
              name
            }
            seller {
              id
              firstname
              lastname
              email
              phone
              address{
              address
              zipCode
              city
              }
              civility
            }
            buyer {
              firstname
              lastname
              email
              phone
             address{
                address
                zipCode
                city
              }
              civility
              departement
              region
              sellerBirthDate
              buyerBirthDate
            }
            vehicule {
              id
              make
              model
              version
              color
              fuel
              licensePlate
              city
              department
              kilometers
              gearType
              releaseDate
              year
              body
              doorsNumber
              photo
              url
              appraisalExpert {
                id
                name
              }
              appraisalDate
              over4years
            }
             paymentMode
            saleRdv {
              id
              address{
                address
                zipCode
                city
              }
             status
              date
              isNewCarRegistrationDeclaredByPartner
            }
            saleRdvExpert {
              id
              name
              phonenumber
              type
              mobile
            }
            promoCode {
              name
              value
            }
            pageInfo {
              totalPages
            }
            department
            region
          }
          }

        `
      },
      newCarRegistrationMutation () {
        return gql`
        mutation {
          updateSaleRdv(
            saleRdvId:${this.order[0].saleRdv[0].id},
            isNewCarRegistrationDeclaredByPartner:${this.isNewCarRegistrationDeclaredByPartner},
          ) {
            id,
            result
            }
         }`
      },
      soldSaleRdvMutation () {
        return gql`
        mutation {
          soldSaleRdv(
            saleRdvId:${this.order[0].saleRdv[0].id}
          ) {
            id,
            status,
            result
            }
         }`
      },
       unsoldSaleRdvMutation () {
        return gql`
        mutation {
          unsoldSaleRdv(
            saleRdvId:"${this.order[0].saleRdv[0].id}",
          ) {
            id,
            status,
            result
            }
         }`
      },
      hasResult () {
        return this.order && this.order.length
      },
      vehicle () {
        return this.hasResult ? this.order[0].vehicule[0] : null
      },
      commercial () {
        return this.hasResult && this.order[0].commercial.id != '' ? this.order[0].commercial : null
      },
      seller () {
        return this.hasResult ? this.order[0].seller[0] : null
      },
      buyer () {
        return this.hasResult ? this.order[0].buyer[0] : null
      },
      commandId () {
        return this.$route.params.id
      },
      saleRdv () {
        return this.hasResult ? this.order[0].saleRdv[0] : null
      },
      saleCommission () {
        return this.hasResult ? this.order[0].saleCommission : null
      },
      status () {
        return this.hasResult ? this.order[0].status : null
      },
      paymentMode () {
        return this.hasResult ? this.order[0].paymentMode : null
      },
      orderId () {
        return this.hasResult ? this.order[0].id : null
      },
      saleRdvExpert () {
        return this.hasResult ? this.order[0].saleRdvExpert[0] : null
      },
      command () {
        return this.hasResult ? this.order[0] : null
      },
      ownerInformationsQuery () {
          return gql`
            query{
              ownerInformation(orderId: "${this.commandId}") {
                owners {
                  hasCoOwner
                  isSellerOwner
                  isSellerCoOwner
                  owner {
                    documentId
                  }
                  coOwner {
                    documentId
                  }
                }
                ownerQuestions {
                  isProfessional
                }
              }
            }`
      },

      futureOwnerQuery() {
          return gql`
            query{
              futureOwner(orderId: "${this.commandId}") {
                isBuyerOwner
                owner {
                  documentId
                }
              }
            }`
      },
      beforeSaleDocumentsRequiredAndValid() {
          const requiredAndValid = this.beforeSaleDocumentsRequired.filter(function(item) {
              return item.valid
          });
          return requiredAndValid
      },

      beforeSaleDocumentsRequired() {
          let required = this.beforeSaleDocuments.filter(function(item) {
              return item.code !== "consVisit"
          });

          if(!this.command.vehicule[0].over4years){
              let requiredStep2 = required.filter(function(item) {
                  return item.code !== "vehicleInspection"
              });

              required = requiredStep2
          }
          return required
      },

      beforeSaleDocumentsReady() {
          if(this.beforeSaleDocumentsRequired.length - this.beforeSaleDocumentsRequiredAndValid.length === 0){
              return true
          } else {
              return false
          }
      },

      saleDocumentsToUploadAndPrintRequiredAndValid() {
          const requiredAndValid = this.saleDocumentsToUploadAndPrintRequired.filter(function(item) {
              return item.valid
          });
          return requiredAndValid
      },

      saleDocumentsToUploadAndPrintRequired() {
          let required = this.saleDocumentsToUploadAndPrint

          if(this.command.options[0].id !== '2' && this.command.options[0].id !== '3'){
              let requiredStep2 = required.filter(function(item) {
                  return item.code !== "warrantyMecanique"
              });

              required = requiredStep2
          }

          return required
      },

      saleDocumentsToUploadBankCheckRequiredAndValid() {
          const requiredAndValid = this.saleDocumentsToUploadBankCheckRequired.filter(function(item) {
              return item.valid
          });
          return requiredAndValid
      },

      saleDocumentsToUploadBankCheckRequired() {

          return this.saleDocumentsToUploadBankCheck
      },

      saleDocumentsToUploadAndConsultRequiredAndValid() {
          const requiredAndValid = this.saleDocumentsToUploadAndConsultRequired.filter(function(item) {
              return item.valid
          });
          return requiredAndValid
      },

      saleDocumentsToUploadAndConsultRequired() {
          const required = this.saleDocumentsToUploadAndConsult.filter(function(item) {
              return item.code !== "procuration"
          });
          return required
      },

      saleDocumentsToGenerateRequiredAndReady() {
          let requiredAndReady = 0

          if(this.saleDocumentsToGenerateAndPrint[0].canGenerate){
              requiredAndReady += 1
          }

          if(this.saleDocumentsToGenerateAndPrint[1].canGenerate){
              requiredAndReady += 1
          }

          if(this.saleDocumentsToGenerateAndPrint[2].canGenerate){
              requiredAndReady += 1
          }

          if(this.saleDocumentsToGenerateAndConsult[0].canGenerate){
              requiredAndReady += 1
          }

          return requiredAndReady
      },

      saleDocumentsToGenerateRequired() {

          return this.saleDocumentsToGenerateAndPrint.length + this.saleDocumentsToGenerateAndConsult.length
      },

      saleDocumentsRequiredAndValid() {
          let result = this.saleDocumentsToUploadAndPrintRequiredAndValid.length + this.saleDocumentsToGenerateRequiredAndReady + this.saleDocumentsToUploadAndConsultRequiredAndValid.length

          if(this.paymentMode == 1){
              result += this.saleDocumentsToUploadBankCheckRequiredAndValid.length
          }

          return result
      },

      saleDocumentsRequired() {
          let result = this.saleDocumentsToUploadAndPrintRequired.length + this.saleDocumentsToGenerateRequired + this.saleDocumentsToUploadAndConsultRequired.length

          if(this.paymentMode == 1){
              result += this.saleDocumentsToUploadBankCheckRequired.length
          }

          return result
      },

      saleDocumentsReady() {
          if(this.saleDocumentsRequired - this.saleDocumentsRequiredAndValid === 0){
              return true
          } else {
              return false
          }
      },
    },
     methods: {
       async fetchProjectDocumentsQuery () {
           // Company documents
           const resultForProjectDocument = await this.$apollo.query({
               query: gql`
                query {
                 projectDocument(orderId: "${this.commandId}") {
                   carRegistration {
                      id
                      valid
                   }
                   consVisit {
                      id
                      valid
                   }
                   vehicleInspection {
                      id
                      valid
                   }
                   nonPedge {
                      id
                      valid
                   }
                   warrantyMecanique {
                      id
                      valid
                   }
                   signedWarrantyMecanique {
                      id
                      valid
                   }
                   disposal {
                      id
                      valid
                   }
                   bankCheck{
                      id
                      valid
                   }
                 }
                }`,
               fetchPolicy: 'no-cache'
           })

           // Before Sale
           if(resultForProjectDocument.data.projectDocument[0].carRegistration.id){
               this.beforeSaleDocuments[0].id = resultForProjectDocument.data.projectDocument[0].carRegistration.id
               this.beforeSaleDocuments[0].valid = resultForProjectDocument.data.projectDocument[0].carRegistration.valid
           }

           if(resultForProjectDocument.data.projectDocument[0].consVisit.id){
               this.beforeSaleDocuments[1].id = resultForProjectDocument.data.projectDocument[0].consVisit.id
               this.beforeSaleDocuments[1].valid = resultForProjectDocument.data.projectDocument[0].consVisit.valid
           }

           if(resultForProjectDocument.data.projectDocument[0].vehicleInspection.id){
               this.beforeSaleDocuments[2].id = resultForProjectDocument.data.projectDocument[0].vehicleInspection.id
               this.beforeSaleDocuments[2].valid = resultForProjectDocument.data.projectDocument[0].vehicleInspection.valid
           }

           // Sale Documents To Upload And Print

           if(resultForProjectDocument.data.projectDocument[0].warrantyMecanique.id){
               this.saleDocumentsToUploadAndPrint[0].id = resultForProjectDocument.data.projectDocument[0].warrantyMecanique.id
               this.saleDocumentsToUploadAndPrint[0].valid = resultForProjectDocument.data.projectDocument[0].warrantyMecanique.valid
           }

           if(resultForProjectDocument.data.projectDocument[0].nonPedge.id){
               this.saleDocumentsToUploadAndPrint[1].id = resultForProjectDocument.data.projectDocument[0].nonPedge.id
               this.saleDocumentsToUploadAndPrint[1].valid = resultForProjectDocument.data.projectDocument[0].nonPedge.valid
           }

           // Sale Documents To Upload Bank Check

           if(resultForProjectDocument.data.projectDocument[0].bankCheck.id){
               this.saleDocumentsToUploadBankCheck[0].id = resultForProjectDocument.data.projectDocument[0].bankCheck.id
               this.saleDocumentsToUploadBankCheck[0].valid = resultForProjectDocument.data.projectDocument[0].bankCheck.valid
           }

           // GET CAN GENERATE DOCUMENTS
           await this.getCanGenerateDocuments()

           // GET CUSTOMER DOCUMENTS
           await this.fetchCustomerDocumentsQuery()
       },
       async fetchCustomerDocumentsQuery () {
           // GET ACTUAL OWNER DATA
           await this.getActualOwnerData ()

           // GET CO-OWNER DATA
           await this.getCoOwnerData ()

           // GET FUTURE OWNER DATA
           await this.getFutureOwnerData ()

           this.isLoading = false
       },
       async getCanGenerateDocuments () {

           // GET CAN GENERATE DOCUMENTS
           const resultCanGenerateDocuments = await this.$apollo.query({
               query: gql`
                query {
                 canGenerateDocuments(orderId: "${this.commandId}") {
                    certifCession {
                      canGenerate
                    }
                    invoice {
                      canGenerate
                    }
                    disposal {
                      canGenerate
                    }
                    expertiseReport {
                      canGenerate
                    }
                 }
                }`,
               fetchPolicy: 'no-cache'
           })

           if(resultCanGenerateDocuments.data.canGenerateDocuments){
               this.saleDocumentsToGenerateAndPrint[0].canGenerate = resultCanGenerateDocuments.data.canGenerateDocuments.certifCession.canGenerate
               this.saleDocumentsToGenerateAndPrint[1].canGenerate = resultCanGenerateDocuments.data.canGenerateDocuments.invoice.canGenerate
               this.saleDocumentsToGenerateAndPrint[2].canGenerate = resultCanGenerateDocuments.data.canGenerateDocuments.disposal.canGenerate
               this.saleDocumentsToGenerateAndConsult[0].canGenerate = resultCanGenerateDocuments.data.canGenerateDocuments.expertiseReport.canGenerate
           }
       },
       async getActualOwnerData () {
         // GET ACTUAL OWNER DATA
         if (null === this.ownerInformation.owners) {
           return;
         }

         const idOwner = this.ownerInformation.owners.owner.documentId

         const resultForCustomerDocumentForOwner = await this.$apollo.query({
           query: gql`
            query {
             customerDocument(documentId: "${idOwner}") {
               procuration {
                  id
                  valid
               }
             }
            }`,
           fetchPolicy: 'no-cache'
         })

         // Owner
         if(resultForCustomerDocumentForOwner.data.customerDocument[0].procuration.id){
             this.saleDocumentsToUploadAndConsult[0].id = resultForCustomerDocumentForOwner.data.customerDocument[0].procuration.id
             this.saleDocumentsToUploadAndConsult[0].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].procuration.valid
         }
       },
       async getCoOwnerData () {
           // GET CO-OWNER DATA
         if (null === this.ownerInformation.owners) {
           return;
         }

         const idCoOwner = this.ownerInformation.owners.coOwner.documentId

         const resultForCustomerDocumentForCoOwner = await this.$apollo.query({
           query: gql`
            query {
             customerDocument(documentId: "${idCoOwner}") {
               procuration {
                  id
                  valid
               }
             }
            }`,
           fetchPolicy: 'no-cache'
         })

         // CoOwner
         if(resultForCustomerDocumentForCoOwner.data.customerDocument[0].procuration.id){
             this.saleDocumentsToUploadAndConsult[1].id = resultForCustomerDocumentForCoOwner.data.customerDocument[0].procuration.id
             this.saleDocumentsToUploadAndConsult[1].valid = resultForCustomerDocumentForCoOwner.data.customerDocument[0].procuration.valid
         }
       },
       async getFutureOwnerData () {
           // GET FUTURE OWNER DATA
           const idFutureOwner = this.futureOwner.owner.documentId

           const resultForCustomerDocumentForFutureOwner = await this.$apollo.query({
               query: gql`
                query {
                 customerDocument(documentId: "${idFutureOwner}") {
                   procuration {
                      id
                      valid
                   }
                 }
                }`,
               fetchPolicy: 'no-cache'
           })

           // Future Owner
           if(resultForCustomerDocumentForFutureOwner.data.customerDocument[0].procuration.id){
               this.saleDocumentsToUploadAndConsult[2].id = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].procuration.id
               this.saleDocumentsToUploadAndConsult[2].valid = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].procuration.valid
           }
       },
       updateCheckedValidDocumentsList(data){
         if(data.checked){
           this.checkedValidDocumentsList.push(data.id);
         } else {
           const index = this.checkedValidDocumentsList.indexOf(data.id);

           if (index > -1) {
               this.checkedValidDocumentsList.splice(index, 1);
           }
         }
       },
       async downloadDocuments () {
           let array = this.checkedValidDocumentsList
           let i
           for (i = 0; i < array.length; i++) {
               const response = await this.getBase64Document(array[i])
               const base64 = response.data.showDocument.files[0].base64

               this.downloadFileFromBase64(base64)
           }
       },
       isCarProclaimedSold () {
         return this.saleRdv.status == 5
       },
       isCarProclaimedUnsold () {
         return this.saleRdv.status == 4
       },
      onSoldProclamation () {
        this.showButton = false
        this.isShowDone()
        this.onNewCarRegistrationUpdate()
        this.onSaleRdvProclamedSold()
        this.closeModal()
      },
      onUnsoldProclamation(){
        this.showButton = false
        this.isShowFail()
        this.closeModal()
        this.onSaleRdvProclamedUnsold()
      },
       isShowFail () {
        this.showFail = true
        this.showRdv = true
      },
       isShowDone () {
        this.showDone = true
        this.showRdv = true
      },
       onCloseModal () {
        this.enterAnimation = false
      },
      onNewCarRegistrationDone () {
        this.isNewCarRegistrationDeclaredByPartner = true
      },
      onNewCarRegistrationNotDone () {
        this.isNewCarRegistrationDeclaredByPartner = false
      },
      onOpenModal () {
        this.enterAnimation = false
      },
      async uploadFile(e, type) {
        try {
          this.$parent.setUploadLoading(true)
          const base64File = await this.getBase64(e.target.files[0])
          const result = await this.$apollo.mutate({
            mutation: gql`
              mutation {
                uploadCustomerDocument (documentId:${this.user.documentId}, files: {
                  type: "${type}", base64_file: "${base64File}"}) {
                  files {
                    filesize,
                    type,
                    id
                  }
                }
              }`
          })
          this.userDocuments[type].id = result.data.uploadCustomerDocument.files[0].id
          this.$parent.setUploadLoading(false)
        } catch (e) {
          this.$parent.setUploadLoading(false)
          this.showBanner('danger', 'Une erreur est survenue lors de l\'enregistrement du document.')
        }
      },
      getBase64Document (id) {
        const query = gql`
          query {
            showDocument(
            files: {
              fileId: ${id}
            })
            {
              files {
                base64
                id
              }
            }
          }`
        return this.$apollo.query({
          query: query
        })
      },
     onNewCarRegistrationUpdate () {
          this.$apollo.mutate({
            mutation: this.newCarRegistrationMutation
          }).then(() => {
            this.saleRdv.isNewCarRegistrationDeclaredByPartner = this.isNewCarRegistrationDeclaredByPartner
            this.showBanner('success', `Succès: la vente a bien été enregistrée`)
          })
      },
      onSaleRdvProclamedSold () {
          this.$apollo.mutate({
            mutation: this.soldSaleRdvMutation
          }).then(() => {
            this.saleRdv.status = 5
            this.showBanner('success', `Succès: la vente a bien été enregistrée`)
          })
      },
      onSaleRdvProclamedUnsold (){
         this.$apollo.mutate({
            mutation: this.unsoldSaleRdvMutation
          }).then(() => {
            this.saleRdv.status = 4
            this.showBanner('warning', `vehicule déclaré non vendu`)
          })
      },
      async downloadDocument (documentId) {
        try{
        const response = await this.getBase64Document(documentId)
        const base64 = response.data.showDocument.files[0].base64
        this.downloadFileFromBase64(base64)
         } catch (e) {
          this.showBanner('danger', 'Le document associé n\'a  pu être téléchargé.')
        }
      }
    },

      mounted () {
      this.fetchProjectDocumentsQuery()
      if (store.data.userInfos) {
        this.userInfos = store.data.userInfos
      } else {
        this.$router.push('/logout')
        this.showBanner('danger', "Désolé, les informations de l'utilisateur connecté ne sont pas disponibles, veuillez vous re-connecter.")
      }
    },

    apollo: {
      order: {
        query () {
          return this.commandDetailQuery
        },
      },
      ownerInformation: {
        query() {
          return this.ownerInformationsQuery
        }
      },
      futureOwner: {
        query() {
          return this.futureOwnerQuery
        }
      },
    }
  }
</script>

<style>
.is-collapsed {
  display: none;
}
/*.fa-pencil {*/
    /*color: #dadada;*/
    /*display: none;*/
/*}*/
</style>